import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

import { feedbackStatusSchema } from "./feedback";

export const updateFeedbackSchema = z.object({
  status: feedbackStatusSchema.optional(),
  adminNote: z.string().max(4000).nullable().optional(),
  tags: z.array(z.string().min(1).max(32)).max(20).optional(),
});

export class UpdateFeedbackDto extends createZodDto(updateFeedbackSchema) {}
export type UpdateFeedbackPayload = z.infer<typeof updateFeedbackSchema>;
